<template>
  <v-dialog v-model="dialog" persistent width="380px">
    <v-card v-if="!!data">
      <v-card-title>{{
        data.courtesy ? "Cortesia" : "Venda em dinheiro"
      }}</v-card-title>
      <v-card-text class="pb-0">
        <v-alert
          v-if="!data.courtesy"
          color="primary"
          border="bottom"
          text
          class="text-center font-weight-bold"
        >
          <p class="lh-1">Receba do cliente</p>
          <span class="font-weight-bold text-24">
            {{ data.totalPrice | currency(true) }}
          </span>
        </v-alert>
        <v-alert
          v-else
          color="primary"
          border="bottom"
          text
          class="text-center font-weight-bold"
        >
          <p class="lh-1">Emitir ingressos como</p>
          <span class="font-weight-bold text-24"> Cortesia </span>
        </v-alert>
        <v-alert style="color: white" dense color="secondary" class="text-13">
          Esse ingresso ficará disponível para o cliente
          <b class="font-weight-bold">imediatamente</b>.
          <span v-if="!data.courtesy">
            O valor da venda ficará registado para recolhimento futuro.
          </span>
          <span v-else>
            Nenhum valor será cobrado do cliente por essa emissão.
          </span>
        </v-alert>
        <h6 class="text-center mb-0">
          Confirmar {{ data.courtesy ? "emissão?" : "venda?" }}
        </h6>
      </v-card-text>
      <v-card-actions class="justify-space-between pb-4">
        <v-btn text @click="close(false)"> Cancelar </v-btn>
        <v-btn color="primary" @click="close(true)" depressed>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    data: null,
  }),
  methods: {
    open(data) {
      this.dialog = true;
      this.data = data;
    },
    close(type = false) {
      this.dialog = false;
      this.$emit("close", type);
      this.$nextTick(() => {
        this.data = null;
      });
    },
  },
  mounted() {
    this.$root.$on("confirm-money-sell", this.open);
  },
};
</script>

<style></style>
